import {
    postProfileLoading,
    postProfileRequest,
    postProfileSuccess,
    postProfileReject,
    postProfileReset
} from "../../actions/profile/post";

export const postProfile = (formData) => async (dispatch, getState) => {
    dispatch(postProfileLoading());
    try {
        const { data } = await postProfileRequest(formData, getState);
        dispatch(postProfileSuccess(data))
    } catch (error) {
        dispatch(postProfileReject(error))
    } finally {
        setTimeout(() => { dispatch(postProfileReset()) }, 3000);
    }
    return Promise.resolve();
};